import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import SearchIcon from '@material-ui/icons/Search';

// Shown on the search page and in the search modal before the user has typed
// anything, instead of the stock "Sorry, no results were found" empty state.
export const PreSearchEmptyState = () => (
  <Box textAlign="center" py={8} px={2}>
    <SearchIcon style={{ fontSize: 64 }} color="disabled" />
    <Typography variant="h6" gutterBottom>
      Search for whatever you want
    </Typography>
    <Typography variant="body2" color="textSecondary">
      Docs, APIs, services — whatever. Just start typing.
    </Typography>
  </Box>
);
